import { client } from '../client';
import { IGMMessage } from './types/IGMMessage';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';
import { UserRoleName } from '../identity/types/UserProfile';

export interface EditMessagePayload {
  author_identity?: string;
  body?: string | null;
}

export const editConversationMessage = async (
  conversationSid: string,
  messageSid: string,
  payload: EditMessagePayload,
  userRole?: string,
): Promise<IGMMessage> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  if (prefix) {
    const { data } = await client.patch(`${prefix}/conversations/${conversationSid}/messages/${messageSid}`, payload);
    return data;
  }
  try {
    const { data } = await client.patch(`/conversations/${conversationSid}/messages/${messageSid}`, payload);
    return data;
  } catch (error: any) {
    if ((!userRole || userRole === UserRoleName.Collector) && error?.response?.status === 403) {
      const collectorPrefix = getStaffScopedApiPrefix(UserRoleName.Collector);
      const { data } = await client.patch(
        `${collectorPrefix}/conversations/${conversationSid}/messages/${messageSid}`,
        payload,
      );
      return data;
    }
    throw error;
  }
};
